module.exports = __webpack_public_path__ + "img/hat05_uv_belt.99236bb0.svg";